import React, { Fragment } from "react";
import styled, { withTheme } from "styled-components";
import { SecondaryNav, IframeRolex } from "@pga/pga-component-library";

import { withAuthProvider } from "../../lib/auth";
import getLinksFor from "./DashboardOptions";

const NavFrame = styled.div`
  padding-bottom: 30px;
  z-index: 5;
  position: relative;

  @media (max-width: 991px) {
    padding: 0;
    margin: 0;
  }
`;

const SecondaryNavWrapper = styled.div`
  position: relative;
  z-index: 10;

  @media (max-width: 991px) {
    /* Ensure menu dropdown items are above Rolex iframe on mobile */
    z-index: 1000;

    /* Target any dropdown menus and menu items specifically to ensure they're above Rolex */
    [role="menu"],
    [role="menuitem"],
    .dropdown-menu,
    ul[role="menu"],
    nav[role="navigation"] > ul,
    nav[role="navigation"] > div > ul {
      z-index: 1001 !important;
      position: relative;
    }

    /* Ensure menu links and buttons are clickable and above Rolex */
    a,
    button {
      position: relative;
      z-index: 1002 !important;
    }
  }
`;

const RolexWrapper = styled.div`
  position: relative;
  z-index: 1;

  @media (max-width: 991px) {
    /* Ensure Rolex iframe is below menu items on mobile */
    z-index: 1;
  }
`;

export const SubNavigation = ({ authReady, isLoggedIn }) => (
  <NavFrame>
    {authReady ? (
      <Fragment>
        <SecondaryNavWrapper>
          <SecondaryNav
            options={getLinksFor(isLoggedIn)}
            title="Jobs"
            menuTitle="Jobs Menu"
          />
        </SecondaryNavWrapper>
        <RolexWrapper>
          <IframeRolex mobile />
        </RolexWrapper>
      </Fragment>
    ) : null}
  </NavFrame>
);

export default withAuthProvider(withTheme(SubNavigation));
